import React from "react"
import Layout from "../components/layout"

export default () => (
  <Layout>
    <div>
      <h1>Page not found.</h1>
      <p>
        The page you are looking for does not exist. It may have been removed or
        relocated.
      </p>
    </div>
  </Layout>
)
